import React from 'react';
import CustomSelect from '../../Components/CustomSelect';
import { t } from '../../i18n/index';

/**
 * Component για το Warehouse filter dropdown
 */
const WarehouseFilter = ({ data, selectedWarehouseId, defaultwarehouseId, language, onChange }) => {
    const warehouses = data["Yms_Warehouses"] || [];
    
    if (warehouses.length === 0) return null;

    const readonly = defaultwarehouseId !== null && defaultwarehouseId !== "";
    const selectedWarehouse = warehouses.find(w => Number(w.WarehouseId) === Number(selectedWarehouseId));

    return (
        <div className="custom-select-wrapper">
            <CustomSelect
                options={warehouses.map(row => ({ value: row.WarehouseId, label: row.Descr1 }))}
                value={selectedWarehouse?.WarehouseId || ""}
                placeholder={selectedWarehouse?.Descr1 || t('truckJourney.selectWarehouse', language)}
                onChange={onChange}
                readonly={readonly}
            />
        </div>
    );
};

export default WarehouseFilter;
